



























































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import CountriesStore from "@/mixins/constants/countriesStore";

// Types
import { ICountry } from "@/models/constants";

@Component
export default class PhoneNumberField extends Mixins(
  RequestPromises,
  CountriesStore
) {
  public $refs!: {
    phone: HTMLFormElement;
  };

  // Props
  @Prop({ default: false })
  public autofocus!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: null })
  public countryCode!: string;

  @Prop({ default: null })
  public phoneCode!: string;

  @Prop({ default: null })
  public brandCountryId!: ICountry["id"];

  @Prop({ default: null })
  public phone!: string;

  @Prop({ default: false })
  public isRequired!: string;

  // Variables
  public phoneCountryCode = "";

  @Watch("phoneCode")
  public watchPhoneCode() {
    this.setPhoneCountryCode();
  }

  @Watch("countryCode")
  public watchCountryCode() {
    this.setPhoneCountryCode();
  }

  public setPhoneCountryCode() {
    const country = this.$_.find(this.countries, constCountry => {
      return this.countryCode
        ? constCountry.code === this.countryCode
        : this.phoneCode
        ? constCountry.phone_code === this.phoneCode
        : constCountry.id === this.brandCountryId;
    });

    this.phoneCountryCode = country ? this.getPhoneCountryCode(country) : "";
  }

  @Watch("countriesLoaded")
  public countriesReady() {
    this.setPhoneCountryCode();
  }

  public get i18n() {
    return {
      phoneCountryCodeLabel:
        this.$t("_.phone_country_code") + `${this.isRequired ? "*" : ""}`,
      phoneCountryCodeAs: this.$t("_.phone_country_code")
        .toString()
        .toLowerCase(),
      phoneLabel: this.$t("_.phone") + `${this.isRequired ? "*" : ""}`,
      phoneLabelAs: this.$t("_.phone")
        .toString()
        .toLowerCase()
    };
  }

  public get countryOptions() {
    return this.$_.filter(
      this.$_.map(this.countries, (country, index) => {
        return {
          id: index,
          code: country.code,
          phone_code: country.phone_code,
          name: country.name,
          label: this.getPhoneCountryCode(country)
        };
      }),
      country => {
        return !!country.phone_code;
      }
    );
  }

  public get filteredDataObj() {
    return this.countryOptions.filter(option => {
      return (
        option.label
          .toString()
          .toLowerCase()
          .indexOf(this.phoneCountryCode.toString().toLowerCase()) >= 0
      );
    });
  }

  public getCountryCode() {
    return this.$_.get(
      this.$_.find(
        this.countries,
        constCountry =>
          this.getPhoneCountryCode(constCountry) === this.phoneCountryCode
      ),
      "code"
    );
  }

  public getPhoneCode() {
    return this.$_.get(
      this.$_.find(
        this.countries,
        constCountry =>
          this.getPhoneCountryCode(constCountry) === this.phoneCountryCode
      ),
      "phone_code"
    );
  }

  public get isPhoneCountryCodeRequired() {
    return this.isRequired || (this.phone !== "" && this.phone !== null);
  }

  public get isPhoneRequired() {
    return this.isRequired || this.phoneCountryCode !== "";
  }

  public getPhoneCountryCode(country) {
    return `${this.$_.get(country, "name")} (${this.$_.get(
      country,
      "phone_code"
    )})`;
  }

  public isValidCode() {
    return (
      this.phoneCountryCode.length &&
      this.$_.findIndex(this.countryOptions, option => {
        return (
          this.phoneCountryCode === `${option.name} (${option.phone_code})`
        );
      }) !== -1
    );
  }

  @Watch("phoneCountryCode")
  public onCountryCodeChanged() {
    if (this.isValidCode()) {
      this.$emit(
        "update:phone_code",
        this.phoneCountryCode ? this.getPhoneCode() : null
      );
      this.$emit(
        "update:phone_country_code",
        this.phoneCountryCode ? this.getCountryCode() : null
      );
    }
  }

  public mounted() {
    this.$nextTick(() => {
      if (this.autofocus) {
        this.$refs.phone.focus();
      }
    });
  }
}
